import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { ctxUser } from '@/contexts/UserContext';
import { ctxPluto } from '@/contexts/PlutoContext';
import { rethrowIfNotClientException } from '@/utilities/throwableUtils';
import { getTargets } from '@/generated/client/targets/targets';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';

// token user eseten betolti a target-et
export function LoadTargetToken() {
  const navigate = useNavigate();
  const userCtx = useContext(ctxUser);
  const ctx = useContext(ctxPluto);
  const order = 'asc';
  const offset = 0;
  const limit = 10;

  useEffect(() => {
    async function loadTarget() {
      try {
        const targets = await getTargets({
          filter: undefined,
          offset: offset,
          limit: limit,
          order: order,
        });
        const target = targets.data?.[0];
        if (target) {
          ctx?.setSelectedTargets([target]);
          ctx?.setFocusedTarget(ctx.fullTargets?.find((t) => t.target.id === target.id));
        }
      } catch (error) {
        rethrowIfNotClientException(error);
      }
    }

    if (!ctx || !userCtx || !userCtx?.isToken()) return;

    // ugly hack
    if (isPhoneOrHighScreen()) {
      if (location.pathname === '/tracking') navigate('/tracking/select' + location.search);
    } else {
      if (location.pathname === '/tracking/select') navigate('/tracking' + location.search);
    }

    if (ctx?.selectedTargets?.length) return; // ez megakadalyozza a vegtelen rendert
    void loadTarget();
  }, [ctx, userCtx]);

  return null;
}
